import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import DownloadPage from './components/DownloadPage';
import NotFound from './components/NotFound';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/:fileId" element={<DownloadPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
